module.exports = __webpack_public_path__ + "img/qrwx.9ab1aced.jpg";